import { icons } from 'lucide-react';
import React, { FC } from 'react';

type IconName = keyof typeof icons;
interface IconProps {
  name: IconName;
  size: number;
  color?: string;
  stroke?: number;
}

export const Icon:FC<IconProps> = ({ name, size, color, stroke = 1.5 }) => {
  const LucideIcon = icons[name];
  return (<LucideIcon size={size} color={color} strokeWidth={stroke} />);
};
